import getDefaultState from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: getDefaultState,
  getters: getters,
  mutations: mutations,
  actions: actions
}
